import SVGIcon from './SVGIcon.webpack';

export default SVGIcon;
